export default "/images/vendor/chocolat/dist/loader.gif?8e92a266ee23f5178e19f912378408d7";